import { createAuthClient } from 'better-auth/react'
import { adminClient } from 'better-auth/client/plugins'
import { ac, roles } from '../../shared/permissions'

// Same origin as the API, so no baseURL is needed.
export const authClient = createAuthClient({ basePath: '/api/auth', plugins: [adminClient({ ac, roles })] })
